module.exports = __webpack_public_path__ + "static/enrollment-hero-77446f36041392a608bd1e7220b4f806.jpg";